import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { EntityService } from "./entity-service";
import { JobService } from "./job-service";
import * as Consts from "../ts/rlAdmin.consts";

export class JobSharedDataService {

    static $inject = ["$q", "entityService", "jobService"];

    job: Models.IEntityCharDataPair;
    jobPromise: ng.IPromise<Models.IEntityCharDataPair>;

    jobInventory: Models.IEntityRelationshipPair[];
    inventoryPromise: ng.IPromise<Models.IEntityRelationshipPair[]>;

    jobStatus: Models.IEntityStatus;
    jobStatusPromise: ng.IPromise<Models.IEntityStatus>;

    constructor(
        private $q: ng.IQService,
        private entityService: EntityService,
        private jobService: JobService) {

        this.jobInventory = null;
        this.job = null;
        this.jobStatus = null;
    }

    RefreshInventory(workOrderID: string) {
        if (this.inventoryPromise == null) {
            this.inventoryPromise = this.entityService.getRelatedEntities(workOrderID, Consts.CharTypeIDs.inventory);
            this.inventoryPromise
                .then((result) => {
                    this.jobInventory = result;
                })
                .finally(() => {
                    this.jobPromise = null;
                });
        }
        return this.inventoryPromise || this.$q.when(this.jobInventory);
    }

    RefreshJob(workOrderID: string) {
        if (this.jobPromise == null) {
            this.jobPromise = this.entityService.getEntity(workOrderID);
            this.jobPromise
                .then((result) => {
                    this.job = result;
                })
                .finally(() => {
                    this.jobPromise = null;
                });
        }
        return this.jobPromise || this.$q.when(this.job);
    }

    RefreshJobStatus(workOrderID: string) {
        if (this.jobStatusPromise == null) {
            this.jobStatusPromise = this.entityService.getEntityStatus(workOrderID);
            this.jobStatusPromise
                .then((result) => {
                    this.jobStatus = result;
                })
                .finally(() => {
                    this.jobStatusPromise = null;
                });
        }
        return this.jobStatusPromise || this.$q.when(this.jobStatus);
    }
}